import { createFileRoute } from '@tanstack/react-router'
import { EnJourneyPage } from '~/components/marketing/en/en-journey-page'
import { MarketingShell } from '~/components/marketing/marketing-shell'
import { marketingPageHead } from '~/lib/site-meta'

const PAGE_TITLE = 'A project’s journey: from first email to handing over the keys | Planno'
const PAGE_DESCRIPTION =
  'Follow an interiors project end to end in Planno: the enquiry that becomes a lead, the brief on a link, the accepted proposal, the client portal, and handover. Five months, told day by day.'

export const Route = createFileRoute('/en/project-journey')({
  component: ProjectJourneyRoute,
  head: () =>
    marketingPageHead({
      description: PAGE_DESCRIPTION,
      locale: 'en',
      path: '/en/project-journey',
      title: PAGE_TITLE,
    }),
})

function ProjectJourneyRoute() {
  return (
    <MarketingShell locale="en">
      <EnJourneyPage />
    </MarketingShell>
  )
}
